
const ContactsPage = () => {
    return (
        <div className="flex items-center justify-center bg-yellow-100">Contacts Page</div>
    )
}

export default ContactsPage